import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-381ca7ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "username-header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "username-label" }, "Add your X username", -1))
const _hoisted_4 = { class: "username-box" }
const _hoisted_5 = ["value", "disabled"]

import { CheckIcon } from '@heroicons/vue/24/outline';
import { ref, watch } from 'vue';
import XIcon from '@/assets/images/x-logo.svg';
import { usePatchSignup } from '@/composables/signup';
import { useClaimStore } from '@/store/claimStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'TwitterUsernameInput',
  props: {
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const store = useClaimStore();

const { patch } = usePatchSignup({
  onSuccess: () => {
    //
  },
  onError: (_error: any) => {
    //
  },
});



const username = ref<string>();

watch(
  () => store.twitterUsername,
  (newUsername) => {
    username.value = newUsername;
  }
);

function createDebounce() {
  let timeout = null;
  return function (fnc, delayMs) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fnc();
    }, delayMs || 500);
  };
}
const debounce = createDebounce();

async function onUsernameInput(event: { target: { value: string } }) {
  // Patch all twitter requirements with the username
  for (const requirement of store.twitterRequirements) {
    await patch({
      userData: { username: event.target.value },
      index: requirement.index,
      type: requirement.type,
    });
  }

  // Update component state
  username.value = event.target.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`twitter-username ${_ctx.disabled ? 'disabled' : ''}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!!_unref(store).twitterUsername)
        ? (_openBlock(), _createBlock(_unref(CheckIcon), {
            key: 0,
            class: "username-icon success"
          }))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "username-icon-x",
            src: _unref(XIcon),
            alt: "X"
          }, null, 8, _hoisted_2)),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("input", {
        class: "username-input",
        name: "username",
        type: "text",
        placeholder: "Your X username",
        value: username.value,
        onInput: _cache[0] || (_cache[0] = (event) => _unref(debounce)(() => onUsernameInput(event))),
        onBlur: _cache[1] || (_cache[1] = (event) => _unref(debounce)(() => onUsernameInput(event), 1)),
        disabled: props.disabled
      }, null, 40, _hoisted_5)
    ])
  ], 2))
}
}

})